/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_4_CtaInputs */

const en_mk_parts_4_cta = /** @type {(inputs: Mk_Parts_4_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See an example`)
};

const id_mk_parts_4_cta = /** @type {(inputs: Mk_Parts_4_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat contohnya`)
};

/**
* | output |
* | --- |
* | "See an example" |
*
* @param {Mk_Parts_4_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_4_cta = /** @type {((inputs?: Mk_Parts_4_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_4_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_4_cta(inputs)
	return en_mk_parts_4_cta(inputs)
});